import {createFileRoute} from '@tanstack/react-router';

import {BaseLayout} from '~components/_layout/BaseLayout';
import {ModelsOverview} from '~components/models/overview/ModelsOverview';

export const Route = createFileRoute('/models/')({
  component: ModelsPage,
  validateSearch: (search: Record<string, unknown>) => {
    return {
      modelsOverviewActiveTab: (search.modelsOverviewActiveTab as string) || undefined,
      projectID: (search.projectID as string) || undefined,
    };
  },
});

function ModelsPage() {
  return (
    <BaseLayout withTitleDivider customContentAndFooter>
      <ModelsOverview />
    </BaseLayout>
  );
}
